// «Un Lead che entra adesso» delle Impostazioni → «Sequenza di chiamate» (piano M5, Task 13; `sequenceExample` di `mockup.js`):
// tentativo per tentativo, la mezza giornata lavorativa in cui cade, a partire da quella in cui il Lead entra (o dalla prima dopo,
// se entra fuori orario), una dopo l'altra; per il primo anche entro quando va fatta la prima chiamata. Lo calcola il server per
// la regola salvata e il browser per la bozza, con le stesse mezze giornate della sequenza (`halfDaysOf`): per questo sta in un
// file suo, senza il resto del dominio (il browser non porta nel bundle il dataset dei comuni).
import { firstCallDeadline, halfDayAt, nextHalfDay } from "./call-sequence-calendar.js";
/**
 * Le mezze giornate dei tentativi di un Lead che entra a `now` con la regola data. Vuoto se il calendario non ha nessuna mezza
 * giornata lavorativa, o se la mattina finisce dopo l'inizio del pomeriggio (una bozza ancora da
 * correggere): non c'è niente da mostrare.
 */
export function sequenceExample(rule, calendar, now) {
    try {
        const deadline = firstCallDeadline(now, rule.firstCallMinutes, calendar, rule);
        let half = halfDayAt(now, calendar, rule).half;
        return rule.attempts.map((_, index) => {
            if (index > 0)
                half = nextHalfDay(half, calendar, rule);
            return { attempt: index + 1, day: half.day, halfDay: half.half, deadline: index === 0 ? deadline : null };
        });
    }
    catch (error) {
        if (error instanceof RangeError)
            return [];
        throw error;
    }
}
//# sourceMappingURL=call-sequence-example.js.map